module.exports = __webpack_public_path__ + "img/SpectroPicDots.17cf4669.png";